import { reactive, ref } from 'vue'
import { deepAssign } from '@xzx-design/utils/deep-assign'
import defaultMessages from './lang/zh-CN'

type Message = Record<string, any>
type Messages = Record<string, Message>

const lang = ref('zh-CN')
const messages = reactive<Messages>({
  'zh-CN': defaultMessages,
})

export const Locale = {
  messages(): Message {
    return messages[lang.value].el
  },

  use(newLang: string, newMessages?: Message) {
    lang.value = newLang
    this.add({ [newLang]: newMessages })
  },

  add(newMessages: Message = {}) {
    deepAssign(messages, newMessages)
  },
}

export const useCurrentLang = () => lang

export type TranslatePair = {
  [key: string]: string | string[] | TranslatePair
}

export type Language = {
  name: string
  el: TranslatePair
}

export default Locale
